import React, { Component, Fragment } from "react"
import styled, { css } from 'styled-components'
import Link from "gatsby-link"
import { find } from 'lodash'
import { rgba } from 'polished'
import Masonry from 'react-masonry-component'
import VisibilitySensor from 'react-visibility-sensor'
import { VelocityComponent} from 'velocity-react'
import { Parallax } from 'react-scroll-parallax'
import SpotifyPlayer from 'react-spotify-player'
import PageTransition from 'gatsby-plugin-page-transitions';
import ReactPlayer from 'react-player'
import moment from 'moment'

import metaAuthor from '../../assets/icons/meta-author.svg'
import metaPhotograhper from '../../assets/icons/meta-photographer.svg'
import metaDate from '../../assets/icons/meta-date.svg'

import facebook from '../../assets/icons/facebook.svg'
import twitter from '../../assets/icons/twitter.svg'
import mail from '../../assets/icons/mail.svg'

import { Header, Carousel, MetaTags } from "../../components"

import { container, heading, bgImage, button, bgIcon, hoverState, padding } from "../../styles/global"
import { width, media } from "../../styles/utils"
import { resolveHeaderType } from "../../styles/fonts";

let lastScrollY = 0;
let ticking = false;

class Article extends Component {

	state = {
        data: null,
        blocks: null,
        acf: null,
        shareActive: false,
        shareFixed: false,
    }

    componentWillMount = () => {
        const data = this.props.data.wordpressArticles;
    
        // Map data to state

        this.setState({
            data: data,
            blocks: JSON.parse(data.acf.content_blocks),
            acf: data.acf
        })
    }

    componentDidMount = () => {
        window.addEventListener('scroll', this.handleScroll);
    }
    

    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.handleScroll);
    }
    
    handleScroll = () => {
        const { shareFixed } = this.state;
        lastScrollY = window.scrollY;
    
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const fixedPoint = (width.phone() ? 800 : 1550) - (width.phone() ? window.innerHeight * 0.7 : window.innerHeight / 2);

                if (lastScrollY >= fixedPoint && !shareFixed) {
                    this.setState({
                        shareFixed: true
                    })
                } 

                if (lastScrollY < fixedPoint && shareFixed) {
                    this.setState({
                        shareFixed: false
                    })
                } 
        
                ticking = false;
            })
       
            ticking = true;
        }
    }

    toggleShare = () => {
        const { shareActive } = this.props;

        if (!shareActive) {
            this.setState({
                shareActive: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        shareActive: false
                    })
                }, 5000);
            })
        }
    }
    
    // Share 

    renderShare = () => {
        const { shareActive, shareFixed } = this.state;

        return (
            <Share
                active={shareActive}
                className={shareFixed ? 'fixed' : ''}
                onClick={this.toggleShare}
            >
                <Heading>Share</Heading>
                <Functions>      
                    {typeof window !== 'undefined' && (
                        <React.Fragment>
                            <Function
                                type={'mail'}
                                target={'_blank'}
                                href={`mailto:?&body=${window.location}`}
                            >
                                <Image/>
                            </Function>
        
                            <Function
                                type={'twitter'}
                                target={'_blank'}
                                href={`https://twitter.com/intent/tweet?url=${encodeURI(window.location)}`}
                            >
                                <Image/>
                            </Function>
        
                            <Function
                                type={'facebook'}
                                target={'_blank'}
                                href={`https://www.facebook.com/sharer.php?u=${window.location}`}
                            >
                                <Image/>
                            </Function>
                        </React.Fragment>
                    )}       
                </Functions>
            </Share>
        )
    }

    // Meta

    getMainSection = () => {
		const { data } = this.state;
		let mainSection = find(data.sections, {isSub: false})
		if (mainSection) {
			return (
				<Tag
					to={`/articles/${mainSection.slug}`}
				>
					{mainSection.name}
				</Tag>
			)
		}
	}

	getFirstSubsection = () => {
		const { data } = this.state;
		let firstSubsection = find(data.sections, {isSub: true})

		if (firstSubsection) {
			return (
				<Tag
					to={`/articles/${firstSubsection.slug}`}
				>
					{firstSubsection.name}
				</Tag>
			)
		}
	}

    // Credits
    
    renderCredits = () => {
        const { data } = this.state;

        return data && (
            <MetaContainer>
                <Meta
                    type={'author'}
                >
                    <Icon />
                    <Mobile>Author:</Mobile>
                    <Text>{data.acf.author}</Text>
                </Meta>

                {data.acf.photographer && (
                    <Meta
                        type={'photographer'}
                    >
                        <Icon />
                        <Mobile>Photographer:</Mobile>
                        <Text>{data.acf.photographer}</Text>
                    </Meta>
                )}

                <Meta
                    type={'date'}
                >
                    <Icon />
                    <Mobile>Date:</Mobile>
                    <Text>{moment.unix(data.publishedDate).format('D MMMM YYYY')}</Text>
                </Meta>
            </MetaContainer>
        )
    }

    // Tags

    renderTags = () => {
        const { data } = this.state;

        if (data && data.tags) {
            const tags = data.tags.map((tag, i) => {
                return (
                    <Tag>
                        {tag.name}
                    </Tag>  
                )
            })
    
            return (
                <TagSection>
                    <Tags>
                        {this.getMainSection()}
                        {this.getFirstSubsection()}
                        {tags}
                    </Tags>
                    <Line/>
                </TagSection>
            )
        }
    }

    // Shop

    renderShop = () => {
        const { acf } = this.state;

        if (acf && acf.shop_display_block) {
            return (
                <Shop>
                    <Heading>{acf.shop_heading || ''}</Heading>
                    <Products>
                        {this.renderShopProducts(acf.shop_products)}
                    </Products>
                </Shop>
            )
        }
    }

    renderShopProducts = (products) => {
        return products.map((product, i) => {
            return (
                <Product
                    href={product.link}
                    key={i}
                >
                    <Image
                        image={`https://${product.image_url}`}
                    />

                    <Info>{product.title}</Info>
                </Product>
            )
        })
    }

    // Block render functions
    
    renderBlocks = () => {
        const { blocks } = this.state;

        if (blocks) {
            return blocks.map((block, i) => {
                const type = block.acf_fc_layout;
                
                return (
                    <Block
                        layout={type}
                        firstBlock={i == 0}
                        key={i}
                    >
                        {type == 'text' && this.renderTextBlock(block)}
                        {type == 'quote' && this.renderQuoteBlock(block)}
                        {type == 'listicle' && this.renderListicleBlock(block)}
                        {type == 'question_answer' && this.renderQABlock(block)}
                        {type == 'image' && this.renderImageBlock(block)}
                        {type == 'video_player' && this.renderVideoBlock(block)}
                        {type == 'spotify_player' && this.renderSpotifyBlock(block)}
                        {type == 'image_slideshow' && this.renderSlideshowBlock(block)}
                    </Block>
                )
            })
        }
    }

    renderTextBlock = (block) => {
        return (
            <Text 
                dangerouslySetInnerHTML={{__html: block.content}}    
            />
        )
    }

    renderQuoteBlock = (block) => {
        return (
            <Text 
                dangerouslySetInnerHTML={{__html: block.content}}    
            />
        )
    }

    renderListicleBlock = (block) => {

        let imageSrc = block.image.sizes.medium2;
        if(block.image.mime_type=='image/gif') imageSrc = block.image.url;

        return (
            <React.Fragment>
                <Line/>
                <Img
                    src={block.image && imageSrc}
                />
                {block.use_caption && (
                    <Caption 
                        dangerouslySetInnerHTML={{__html: block.caption}}    
                    />
                )}
                <Heading>
                    <Number>#{block.number}</Number>
                    <HeadingText>{block.heading}</HeadingText>
                </Heading>
                <Text 
                    dangerouslySetInnerHTML={{__html: block.text}}    
                />
            </React.Fragment>
        )
    }

    renderQABlock = (block) => {
        return (
            <React.Fragment>
                <Question 
                    dangerouslySetInnerHTML={{__html: block.question}}    
                />
                <Answer 
                    dangerouslySetInnerHTML={{__html: block.answer}}    
                />
            </React.Fragment>
        )
    }

    renderImageBlock = (block) => {

        if(!block.image) return

        let imageSrc = block.image.sizes.medium2;
        if(block.image.mime_type=='image/gif') imageSrc = block.image.url;

        return (
            <React.Fragment>             
                <Img
                    src={imageSrc}
                />
                {block.use_caption && (
                    <Caption 
                        dangerouslySetInnerHTML={{__html: block.caption}}    
                    />
                )}
            </React.Fragment>      
        )
    }

    renderVideoBlock = (block) => {
        return (
            <ReactPlayer 
                url={block.src}
                controls 
                height={width.phone() ? '204px' : '475px'}
                width={'100%'}
            />
        )
    }

    renderSpotifyBlock = (block) => {
        return (
            <SpotifyPlayer
                uri={block.uri}
                size={'large'}
                view={'list'}
                theme={'white'}
            />
        )
    }    

    renderSlideshowBlock = (block) => {

        const slides = block.slider.map((slide, i) => {

            let imageSrc = slide.image.sizes.fullwidth;
            if(slide.image.mime_type=='image/gif') imageSrc = slide.image.url;

			return (
                <Image
                    image={imageSrc}
                />
            )
        })  

        return (
            <React.Fragment>
                <Carousel
                    slides={slides}
                    ref={this.slider}
                    styles={carouselStyles}
                    controls={true}
                    settings={{
                        dots: false,
                        infinite: true,
                        speed: 1000,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        autoplaySpeed: 400,
                        pauseOnHover: false
                    }}
                />
                {block.use_caption && (
                    <Caption 
                        dangerouslySetInnerHTML={{__html: block.caption}}    
                    />
                )}
            </React.Fragment>
        )

    }

  	render() {
        const { data, acf } = this.state;

        return (
            <PageTransition>
                
                {data && (
                    <MetaTags 
                        title={`Mambo World — ${data.title}`}
                        description={acf.meta_description}
                        url={`https://www.mamboworld.com.au/article/${data.slug}`}
                        image={acf.hero_image.sizes.medium2}
                    />
                )}

                <Wrapper>

                    {data && (
                        <Hero
                            height={acf.height}
                            image={acf.hero_image && acf.hero_image.sizes.xlarge}
                        />
                    )}

                    <Container>
                       
                        {data && (
                            <ArticleHeading
                                type={acf.title_style}
                            >
                                {data.title}
                            </ArticleHeading>
                        )}

                        {data && data.acf.byline && (
                            <ArticleByline>
                                {data.acf.byline}
                            </ArticleByline>
                        )}

                        {this.renderCredits()}
                        {this.renderBlocks()}
                        {this.renderTags()}
                        {this.renderShop()}
                        {this.renderShare()}
                        
                    </Container>
                </Wrapper>
            </PageTransition>
		)	
  	}
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;	
	width: 100%;
	color: black;	
    position: relative;
`

const Container = styled.div`
    ${container}
    ${padding}
	flex-direction: column;
    align-items: center;	
    padding-bottom: 120px;
    flex: 1;

    ${media.phone`
        padding-bottom: 80px;
    `}
`

// Shared

const Text = styled.div``
const Heading = styled.div``
const Mobile = styled.div``
const Image = styled.div`
    background-image: url(${props => props.image});
    ${bgImage}
`

const Img = styled.img`
    width: 100%;
    height: auto;
`

const Caption = styled.div`
    font-family: 'GT America';
    font-weight: 300;
    text-align: center;
    margin: 0 auto;
    padding: 20px 40px;
    font-size: 16px;
    ${media.phone`
        font-size: 13px;
    `}  
`

const Line = styled.div`
    width: 100%;
    border-top: 2px solid black;
`

// Hero

const Hero = styled.div`
    height: ${props => props.height ? props.height : 650}px;
    width: 100%;
    background: ${rgba('black', 0.2)};
    background-image: url(${props => props.image});
    ${bgImage};

    ${media.phone`
        height: 180px;
    `}  
`

// Heading

const ArticleHeading = styled.div`
    font-size: 75px;
    line-height: 75px;
    text-transform: uppercase;
    text-align: center;
    margin-top: 90px;
    max-width: 790px;

    ${props => resolveHeaderType(props.type)}

    ${media.tablet`
        margin-top: 45px;
    `}

    ${media.phone`
        margin-top: 35px;
        font-size: 30px;
        line-height: 32px;
    `}
`

// Byline

const ArticleByline = styled.div`
    font-family: 'GT America';
    font-size: 32px;
    line-height: 42px;
    font-weight: 300;
    text-align: center;
    margin-top: 10px;
    max-width: 800px;

    ${media.phone`
        font-size: 18px;
        line-height: 28px;
    `}
`

// Credits

const MetaContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 22px;

    ${media.phone`
        flex-direction: column;
        margin-top: 10px;
    `}
`

const Icon = styled.div`
    ${bgIcon}
    margin-right: 8px;
`

const Meta = styled.div`
    display: flex;
    align-items: center;

    ${Text},
    ${Mobile} {
        font-family: 'GT America Expanded Bold';
        font-size: 12px;
        text-transform: uppercase;
    }

    ${Mobile} {
        display: none;
        margin-right: 8px;
        color: #B1B1B1;
    }

    &:not(:last-child) {
        margin-right: 38px;
    }

    ${props => {
        if (props.type == 'author') return css`
            ${Icon} {
                width: 27px;
                height: 28px;
                background-image: url(${metaAuthor});
            }
        `

        if (props.type == 'photographer') return css`
            ${Icon} {
                width: 32px;
                height: 25px;
                background-image: url(${metaPhotograhper});
                transform: translateY(-2px)
            }
        `

        if (props.type == 'date') return css`
            ${Icon} {
                width: 28px;
                height: 28px;
                background-image: url(${metaDate});
            }
        `
    }}

    ${media.phone` 
        ${Text},
        ${Mobile} {     
            font-size: 10px;
        }

        ${Mobile} {
            display: flex;
        }

        ${Icon} {
            display: none;
        }

        &:not(:last-child) {
            margin-right: 0;
            margin-bottom: 2px;
        }

    `}
`

// Blocks

const blockWidth = '880px';

const Block = styled.div`
    padding: 0 20px;
    margin-top: ${props => props.firstBlock ? 70 : 70}px;
    box-sizing: border-box;
    width: 100%;
    max-width: ${blockWidth};

    p:last-child {
        margin-bottom: 0;
    }

    /* Default Type */

    font-family: 'GT America';
    font-weight: 300;
    text-align: center;

    ${media.phone`
        margin-top: ${props => props.firstBlock ? 30 : 55}px;
        padding: 0;
    `}

    ${props => {
        if (props.layout == 'text') return blockText
        if (props.layout == 'image') return blockImage
        if (props.layout == 'question_answer') return blockQA
        if (props.layout == 'video') return blockVideo
        if (props.layout == 'spotify_player') return blockSpotify
        if (props.layout == 'listicle') return blockListicle
        if (props.layout == 'quote') return blockQuote
        if (props.layout == 'image_slideshow') return blockSlideshow
    }}  
`

// Block Text

const blockText = css`
    ${Text} {
        font-size: 20px;
        line-height: 34px;

        ${media.phone`
            font-size: 14px;
            line-height: 24px;
        `}
    }
`


// Block Image

const blockImage = css`
    ${Img} {
        /* height: 420px; */
        border: 2px solid black;

        ${media.phone`
            /* height: 204px; */
        `}
    }
`

// Block Slideshow

const blockSlideshow = css`

`

const carouselStyles = css`
    > *:first-child {
        border: 2px solid black;
    }
    
    ${Image} {
        height: 502px;

        ${media.phone`
            height: 204px;
        `}
    }
`

// Block Listicle

const Number = styled.div``
const HeadingText = styled.div``

const blockListicle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 8px;
    margin-top: 78px;

    ${Line} {
        margin-bottom: 78px;
    }

    ${Img} { 
        /* height: 420px; */
        border: 2px solid black;
        box-sizing: border-box;
        width: 100%;
    }

    ${Heading} {
        margin: 35px 0 28px;
        text-align: center;
        max-width: 720px;

        ${Number}, 
        ${HeadingText} {
            margin-top: 30px;
            display: inline;
            font-family: 'GT America Condensed Bold';
            font-size: 32px;
            line-height: 40px;
            text-transform: uppercase;
        }

        ${Number} {
            color: #F03232;
            margin-right: 8px;
        }
    }

    ${Text} {
        font-size: 20px;
        line-height: 34px;

        ${media.phone`
            font-size: 14px;
            line-height: 24px;
        `}
    }

    ${media.phone`
        ${Heading} {
            margin: 24px 0 18px;

            ${Number}, 
            ${HeadingText} {
                font-size: 20px;
                line-height: 30px;
            }

            ${Number} {
                margin-right: 4px;
            }
        }

        ${Line} {
            margin-bottom: 38px;
        }

        ${Image} {
            height: 165px;
        }
    `}
`


// Block QA

const Question = styled.div``
const Answer = styled.div``

const blockQA = css`    
    ${Question},
    ${Answer} {
        font-size: 20px;
        line-height: 34px;

        ${media.phone`
            font-size: 14px;
            line-height: 24px;
        `}
    }

    ${Question} {
        font-weight: 500;
        margin-bottom: 16px;
    }
`

// Block Video

const blockQuote = css`
    ${Text} {
        font-size: 40px;
        line-height: 60px;
        font-family: 'GT America Condensed Bold';

        ${media.phone`
            font-size: 20px;
            line-height: 30px;
        `}
    }
`

// Block Video

const blockVideo = css`
`

// Block Spotify

const blockSpotify = css`    
    iframe {
        width: 100%;   
    }
`

// Tags

const TagSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: ${blockWidth};
    padding: 0 20px;
    box-sizing: border-box;
    width: 100%;
    margin-top: 80px;

    ${media.phone`
        margin-top: 60px;
    `}
`

const Tags = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 77px;

    ${media.phone`
        margin-bottom: 60px;
    `}
`

const Tag = styled.div`
    padding: 0 6px;
	border: 2px solid black;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;	
	font-family: 'GT America Expanded Bold';
	font-size: 12px;
	text-transform: uppercase;
	font-size: 9px;
	color: black;
	padding-bottom: 1px;
	box-sizing: border-box;

	&:not(:last-child) {
		margin-right: 5px;
	}

	${media.phone`
		font-size: 8px;
		border: 1px solid black;
		height: 19px;
	`}
`

// Shop

const Shop = styled.div`
    width: 100%;
    margin-top: 4px;
    max-width: ${blockWidth};
    padding: 0 20px;
    box-sizing: border-box;

    ${Heading} {
        margin: 70px 0;
        font-family: 'GT America Expanded Bold';
        font-size: 20px;
        color: #000000;
        letter-spacing: 0;
        text-align: center;

        ${media.phone`
            font-size: 16px;
            margin: 41px 0;
        `}
    }
`

const Products = styled.div`
    display: flex;
    justify-content: center;
    flex-flow: row wrap;

    ${media.phone`
        flex-direction: column;
        align-items: center;
    `}
`

const Product = styled.a`
    border: 2px solid black;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 1 350px;
    max-width: 350px;
    margin-bottom: 40px;

    ${Image} {
        height: 350px;
    }

    &:nth-child(odd){
        margin-right: 40px;
    }

    ${media.phone`
        max-width: 270px;
        width: 100%;
        flex: 0 1 auto;

        ${Image} {
            height: 270px;
        }
    
        &:not(:last-child) {
            margin-right: 0;
            margin-bottom: 15px;
        }

    `}
`

const Info = styled.div`
    font-family: 'GT America Expanded Bold';
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    color: black;
    height: 60px;
    border-top: 2px solid black;

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;

    &:hover {
        color: white;
        background: black;
    }
`

// Share

const Share = styled.div`
    height: 123px;
    width: 232px;

    display: flex;
    flex-direction: column;
    background: white;
    user-select: none;

    border: 2px solid #000000;
	box-shadow: -10px 10px 0 0 #000000;
	box-sizing: border-box;
	transform: translate(128px, -50%) rotate(-90deg);
    transition: transform 0.25s ease;
    cursor: pointer;

    position: absolute;
    top: 1550px;
    right: 0;

    ${Heading} {
        font-family: 'GT America Expanded Bold';
        font-size: 15px;
        text-transform: uppercase;
        border-top: 2px solid black;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: rotate(-180deg);
    }

    ${props => {
        if (props.active) return css`
            transform: translate(18px, -50%) rotate(-90deg);
        `

        if (!props.active) return css`
            &:hover {
                transform: translate(113px, -50%) rotate(-90deg);

                ${media.phone`
                    transform: none;
                `}
            }
        `
    }}

    &.fixed {
        position: fixed;
        top: 50vh;
        right: 0;
    }

    ${media.phone`
        position: static !important;
        transform: none;
        width: 176px;
        height: 98px;
        box-shadow: 10px 10px 0 0 #000000;
        margin-top: 57px;

        ${Heading} {
            height: 40px;
            font-size: 12px;
            transform: none;
            order: 2;
        }
    `}
`

const Functions = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    /* height: 100%; */
`


const Function = styled.a`    
    ${bgIcon}
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    cursor: pointer;

    ${Image} {
        transition: all 0.25s ease;
        transform: rotate(90deg)
    }

    &:not(:last-child) {
        border-right: 2px solid black;
    }

    ${props => {
        if (props.type == 'facebook') return css`
            ${Image} {
                background-image: url(${facebook});
                width: 28px;
                height: 39px;

                ${media.phone`
                    width: 21px;
                    height: 29px;
                    order: 1;
                `}
            }
        `

        if (props.type == 'twitter') return css`
            ${Image} {
                background-image: url(${twitter});
                width: 40px;
                height: 35px;

                ${media.phone`
                    width: 29px;
                    height: 25px;
                    order: 2;
                `}
            }
        `

        if (props.type == 'mail') return css`
            ${Image} {
                background-image: url(${mail});
                width: 43px;
                height: 29px;

                ${media.phone`
                    width: 31px;
                    height: 22px;
                    order: 3;
                `}
            }
        `
    }}

    &:hover {
        ${Image} {
            transform: rotate(75deg)
        }
    }

    ${media.phone`

        &:first-child {
            order: 3;
            border-right: 0;
        }

        &:nth-child(2) {
            order: 1;
            border-left: 2px solid black;
        }

        ${Image} {
            transform: none;
        }
    `}
`

export const pageQuery = graphql`
	query ArticleBySlug($slug: String!) {
		wordpressArticles(slug: { eq: $slug }) {
            title
            slug
            publishedDate  
            mainSection
            sections {
                ... on sections_4 {
                    name
                    slug       
                    isSub     
                }
            }
            tags {
                ... on tags_2 {
                    name
                    slug
                }
            }
            acf {
                meta_description
                byline
                title_style
                author
                photographer
                shop_display_block
                height
                shop_heading
                shop_products {
                    title
                    link
                    image_url    
                }
                hero_image {
                    sizes {
                       xlarge
                       medium2
                    }
                }
                content_blocks
            }
        }
    }   
`


export default Article



// WEBPACK FOOTER //
// ./src/templates/article/article.js